import classNames from "classnames";
import HideIf from "util/HideIf";
import styles from "./checkbox.module.scss";

interface ICheckBox {
  checked: boolean,
  label?: string,
  className?: string,
  checkboxStyles?: object,
  onChange: () => void,
  radio?: boolean,
  id?: string,
  isAfterLabel?: boolean,
  disabled?: boolean,
}

function Checkbox(props: ICheckBox) {
  const {
    checked, label, className, checkboxStyles, onChange, radio, id, isAfterLabel,
    disabled,
  } = props;

  return (
    <label
      className={classNames(styles.checkbox_wrapper, {
        [styles.unchecked]: !checked,
      }, className)}
      id={id}
      onClick={(event) => {
        // Clicking on label clicks both on label & input. So, onClick is called twice which might result in wrong selection
        event.preventDefault();
        onChange();
      }}
    >
      {!isAfterLabel && label}
      <input
        type="checkbox"
        checked={checked}
        readOnly
        disabled={disabled}
        // onChange={onChange}
      />
      <HideIf show={radio}>
        <span
          className={classNames({
            // [styles.checked]: checked && !radio,
            // [styles.checkbox]: !radio,
            [styles.radio]: radio,
            [styles.radio_checked]: radio && checked,
          }, "bucket-checkbox")}
          style={checkboxStyles}
          id={`${id}-span`}
        />
      </HideIf>
      <HideIf show={!radio}>
        <div
          className={classNames(styles.custom_checkbox, {
            [styles.custom_checkbox_checked]: checked,
          })}
          style={checkboxStyles}
        >
          {checked && <span className={styles.checkmark} />}
        </div>
      </HideIf>
      {isAfterLabel && label}
    </label>
  );
}

export default Checkbox;
